import { ComponentProps, FC } from 'react';
import { BasicModal } from '../BasicModal/BasicModal';
import { getVideoEmbed } from '../VideoEmbed/VideoEmbed.helper';

type Props = {
  videoUrl: string;
} & Pick<ComponentProps<typeof BasicModal>, 'isOpen' | 'onClose'>;

export const VideoModal: FC<Props> = ({ videoUrl, ...props }) => {
  const videoEmbed = getVideoEmbed(videoUrl, true);

  if (!videoEmbed) {
    return null;
  }

  return (
    <BasicModal {...props} id="VideoModal" title="Video" hideTitle className="VideoModal">
      <iframe
        width={1280}
        height={720}
        src={videoEmbed}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded video"
        className="VideoModal-video"
      />
    </BasicModal>
  );
};
